import { VA_FORM_IDS } from '@department-of-veterans-affairs/platform-forms/constants';
import { get0781TrackingDefaults, trackAction } from './datadogRumTracking';

const withSyncModern0781Flow = base => {
  const { syncModern0781Flow } = get0781TrackingDefaults();
  return syncModern0781Flow !== undefined
    ? { ...base, syncModern0781Flow }
    : base;
};

export const track0781WorkflowChoiceSelected = ({ workflowChoice }) => {
  trackAction(
    '0781 - Workflow choice selected',
    withSyncModern0781Flow({
      formId: VA_FORM_IDS.FORM_21_526EZ,
      workflowChoice: workflowChoice ?? '',
    }),
  );
};

export const track0781DocumentUploadSuccess = ({ fileType, fileSize }) => {
  const payload = {
    formId: VA_FORM_IDS.FORM_21_526EZ,
    fileType: fileType ?? '',
  };
  if (typeof fileSize === 'number') {
    payload.fileSize = fileSize;
  }
  trackAction(
    '0781 - Document upload success',
    withSyncModern0781Flow(payload),
  );
};

export const track0781DocumentUploadFailure = ({
  errorMessage,
  fileType,
  fileSize,
}) => {
  const payload = {
    formId: VA_FORM_IDS.FORM_21_526EZ,
    errorMessage: String(errorMessage ?? '').slice(0, 500),
    fileType: fileType ?? '',
  };
  if (typeof fileSize === 'number') {
    payload.fileSize = fileSize;
  }
  trackAction(
    '0781 - Document upload failure',
    withSyncModern0781Flow(payload),
  );
};

export const track0781ReviewPageReached = ({ workflowChoice }) => {
  trackAction(
    '0781 - Review page reached',
    withSyncModern0781Flow({
      formId: VA_FORM_IDS.FORM_21_526EZ,
      workflowChoice: workflowChoice ?? '',
    }),
  );
};

export const track0781FormSubmissionWith0781Data = ({ workflowChoice }) => {
  let sourcePath = '';
  try {
    sourcePath = window?.location?.pathname || '';
  } catch {
    sourcePath = '';
  }
  trackAction(
    '0781 - Form submission with 0781 data',
    withSyncModern0781Flow({
      formId: VA_FORM_IDS.FORM_21_526EZ,
      workflowChoice: workflowChoice ?? '',
      sourcePath,
    }),
  );
};
